import {
    Box,
    Button,
    Collapse,
    Divider,
    IconButton,
    Link,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Dialog,
    Typography,
} from '@mui/material';
import styles from '../../infoblock.module.css';
import { ReactComponent as ArrowBackIcon } from '../../../assets/icons/ic_action_back.svg';
import { ReactComponent as ArrowForwardIcon } from '../../../assets/icons/ic_arrow_forward.svg';
import ActionIconBtn from '../../../frame/components/btns/ActionIconBtn';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import AppContext, {
    isTrack,
    isLocalTrack,
    OBJECT_SEARCH,
    OBJECT_TYPE_FAVORITE,
    OBJECT_TYPE_POI,
    OBJECT_TYPE_SHARE_FILE,
    OBJECT_TYPE_STOP,
} from '../../../context/AppContext';
import HeaderWithUnderline from '../../../frame/components/header/HeaderWithUnderline';
import { ReactComponent as TimeIcon } from '../../../assets/icons/ic_action_date_start.svg';
import { ReactComponent as FolderIcon } from '../../../assets/icons/ic_action_folder.svg';
import { ReactComponent as TrackIcon } from '../../../assets/icons/ic_action_polygom_dark.svg';
import { ReactComponent as LocationIcon } from '../../../assets/icons/ic_action_coordinates_location.svg';
import { ReactComponent as OsmIcon } from '../../../assets/icons/ic_action_openstreetmap_logo.svg';
import { ReactComponent as DescriptionIcon } from '../../../assets/icons/ic_action_note_dark.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/ic_action_info_dark.svg';
import { ReactComponent as WikiIcon } from '../../../assets/icons/ic_plugin_wikipedia.svg';
import {
    cleanHtml,
    DEFAULT_ICON_COLOR,
    DEFAULT_POI_COLOR,
    DEFAULT_POI_SHAPE,
    getFirstSubstring,
    findTranslatedTag,
    getFinalPoiIconName,
    hasTypeTranslation,
    navigateToPin,
    navigateToPoi,
} from '../../../manager/PoiManager';
import { changeIconColor, createPoiIcon, removeShadowFromIconWpt } from '../../../map/markers/MarkerOptions';
import FavoritesManager, {
    findSelectedWpt,
    navigateToFavoritesMenu,
    resolveWptAppearance,
} from '../../../manager/FavoritesManager';
import { ExpandLess, ExpandMore, Folder } from '@mui/icons-material';
import FavoriteActionsButtons from './actions/FavoriteActionsButtons';
import WptTagsProvider, {
    filterTag,
    FINAL_POI_ICON_NAME,
    GRAPH_URL_ENDPOINT,
    MAPILLARY_OSM_TAG,
    openWikivoyageContent,
    OPENING_HOURS,
    AMENITY_PREFIX,
    OSM_PREFIX,
    otherImgTags,
    PARAM_ACCESS_TOKEN,
    PARAM_FIELDS,
    POI_OSM_URL,
    WIKIDATA,
    WIKIPEDIA,
    addWikidataTags,
    getOsmIdFromOsmUrl,
    getShortDescriptionKey,
    getShortDescriptions,
    ICON_KEY_NAME,
    POI_FROM_TAGS,
    POI_ID,
    POI_SUBTYPE,
    TRANSPORT_STOP_ID,
    stringifyTagValues,
} from './WptTagsProvider';
import WptTagInfo from './WptTagInfo';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import MenuItemWithLines from '../../../menu/components/MenuItemWithLines';
import { apiGet, apiPost } from '../../../util/HttpApi';
import Loading from '../../../menu/errors/Loading';
import PhotoGallery from '../../../menu/search/explore/PhotoGallery';
import wptStyles from '../wpt/wptDetails.module.css';
import parse from 'html-react-parser';
import { getWikiLang } from '../../../util/lang';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { getPropsFromSearchResultItem } from '../../../menu/search/search/SearchResultItem';
import { iconPathMap, getIconFromMap } from '../../../map/util/MapManager';
import { SEARCH_ICON_MAP_LOCATION } from '../../../manager/searchConstants';
import {
    TRANSPORT_STOP_SHIELD_COLOR,
    TRANSPORT_STOP_BACKGROUND,
    TRANSPORT_STOP_ICON_NAME,
} from '../../../map/layers/TransportStopsLayer';
import TransportStopsRoutes from './transport/TransportStopsRoutes';
import capitalize from 'lodash-es/capitalize';
import { getResolvedPointsGroups, prepareName } from '../../../manager/track/TracksManager';
import { getCategory } from '../../../menu/search/explore/WikiPlacesItem';
import PoiActionsButtons from './actions/PoiActionsButtons';
import TransportStopActionsButtons from './actions/TransportStopActionsButtons';
import { fmt } from '../../../util/dateFmt';
import { FAVORITES_KEY, POI_OBJECTS_KEY, useRecentDataSaver } from '../../../util/hooks/menu/useRecentDataSaver';
import {
    EXPLORE_URL,
    HEADER_SIZE,
    MAIN_URL_WITH_SLASH,
    POI_LAYER_ID,
    SEARCH_RESULT_URL,
    SEARCH_URL,
    liveHash,
} from '../../../manager/GlobalManager';
import { useWindowSize } from '../../../util/hooks/useWindowSize';
import { useDelayedFlag } from '../../../util/hooks/useDelayedFlag';
import gStyles from '../../../menu/gstylesmenu.module.css';
import { buildSearchParamsFromQuery } from '../../../util/hooks/search/useSearchNav';
import {
    createMapObject,
    isFavoriteFromSearch,
    isWptFromSearch,
    navigateBackToSearchResults,
    closeWikiPoi,
} from '../../../manager/SearchManager';
import { useLocation, useNavigate } from 'react-router-dom';
import LocationInfoLine from '../common/LocationInfoLine';
import OpeningHoursInfo, { getOpeningHours } from './OpeningHoursInfo';
import {
    getOpeningHoursInfoApi,
    getPoiApi,
    getPoiByMapObjectApi,
    getTransportStopApi,
} from '../../../manager/SearchApi';
import LoginContext from '../../../context/LoginContext';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';

export const WptIcon = ({ wpt = null, color, background, icon, iconSize, shieldSize, ctx }) => {
    const [iconState, setIconState] = useState({ svg: null, isLoading: true });
    const cachedIcon = ctx.poiIconCache[icon];

    useEffect(() => {
        const loadIcon = async () => {
            setIconState({ svg: null, isLoading: true });

            try {
                const svg = iconPathMap[icon] ? await getIconFromMap(icon) : (cachedIcon ?? null);
                setIconState({ svg, isLoading: false });
            } catch (error) {
                setIconState({ svg: null, isLoading: false });
            }
        };
        loadIcon().then();
    }, [icon, cachedIcon]);

    if (iconState.isLoading) {
        return <div style={{ display: 'flex', width: shieldSize, height: shieldSize }} />;
    }

    const coloredSvg = iconState.svg ? changeIconColor(iconState.svg, DEFAULT_ICON_COLOR) : null;

    const iconHtml = createPoiIcon({
        color: color,
        background: background,
        hasBackgroundLight: false,
        svgIcon: coloredSvg,
        iconSize: iconSize,
        backgroundSize: shieldSize,
        point: wpt,
        icon: icon === SEARCH_ICON_MAP_LOCATION ? null : icon,
    }).options.html;

    return (
        <div
            style={{ display: 'flex' }}
            dangerouslySetInnerHTML={{
                __html: removeShadowFromIconWpt(iconHtml) + EMPTY_STRING,
            }}
        />
    );
};

export function getObjType(wpt, t) {
    if (!wpt) {
        return TYPE_NOT_FOUND;
    }
    if (wpt?.type?.isStop) {
        return t('web:public_transport_stop_position');
    }
    let type = wpt?.poiType;
    if (!wpt.name || wpt.name === EMPTY_STRING) {
        type = wpt?.tags?.type ?? wpt?.poiType;
    }
    return capitalize(getFirstSubstring(type));
}

export const ADDRESS_NOT_FOUND = i18n.t('web:no_data');
export const TYPE_NOT_FOUND = 'No type';
export const EMPTY_STRING = '';
// keeps the header layout of an MVT preview until the type and icon are loaded
const TYPE_PLACEHOLDER = '\u00A0'; // Non-breaking space
// loading indicators are shown only for a long loading, not to flicker
const LOADING_DELAY_MS = 1000;

export async function getAddressByLatLon(lat, lon) {
    if (lat == null || lon == null) return null;
    const response = await apiGet(`${process.env.REACT_APP_ROUTING_API_SITE}/search/get-poi-address`, {
        apiCache: true,
        params: { lat, lon },
    });
    if (response?.data) {
        return response.data
            .replace(/ str\./g, '')
            .replace(/ city/g, ',')
            .replace(/ dist.*/g, '');
    }

    return null;
}

export default function WptDetails({ setOpenWptTab, setShowInfoBlock }) {
    const ctx = useContext(AppContext);
    const ltx = useContext(LoginContext);
    const { t } = useTranslation();

    const navigate = useNavigate();
    const location = useLocation();
    const hash = location.hash;
    const [, height] = useWindowSize();

    const recentSaver = useRecentDataSaver();

    const [devWikiContent, setDevWikiContent] = useState(null);

    const ICON_IMG_SIZE = 24;
    const ICON_SHIELD_SIZE = 48;

    const [wpt, setWpt] = useState(null);
    const [loading, setLoading] = useState(false);

    const [isAddressAdded, setIsAddressAdded] = useState(false);
    const [isPhotosAdded, setIsPhotosAdded] = useState(false);

    const showLoading = useDelayedFlag(loading, LOADING_DELAY_MS);
    const showPendingLoading = useDelayedFlag(Boolean(wpt?.pending), LOADING_DELAY_MS);

    const renderedTags = useMemo(() => {
        const tags = wpt?.tags?.res;
        if (!tags) return [];

        const otherTags = [];
        let wikidataTag = null;

        for (const tag of tags) {
            if (tag.key?.includes(WIKIDATA)) {
                wikidataTag = tag;
            } else {
                otherTags.push(tag);
            }
        }

        return wikidataTag ? [...otherTags, wikidataTag] : otherTags;
    }, [wpt?.tags?.res]);

    const [delayedHash, setDelayedHash] = useState(hash);
    const debouncerTimer = useRef(0);
    // debounce map move/scroll
    useEffect(() => {
        debouncerTimer.current > 0 && clearTimeout(debouncerTimer.current);
        debouncerTimer.current = setTimeout(() => {
            debouncerTimer.current = 0;
            setDelayedHash(hash);
        }, 1000);

        return () => {
            clearTimeout(debouncerTimer.current);
        };
    }, [hash]);

    const newWpt = useMemo(() => {
        if (!ctx.selectedWpt) return null;

        const type = getWptType(ctx.selectedWpt);
        if (type?.isWikiPoi) {
            setLoading(true);
            const currentPoi = ctx.selectedWpt.poi;
            const mapObj = ctx.selectedWpt.mapObj;
            const wikiObj = ctx.searchSettings.getPoi ?? ctx.selectedWpt.wikidata;
            const wikidataId = wikiObj.properties?.id || ctx.selectedWpt.wikidata.properties.id;
            const coords = wikiObj.geometry.coordinates;
            const poiType = getCategory(wikiObj.properties);
            return {
                id: wikiObj?.properties.id,
                elo: wikiObj?.properties.elo,
                type,
                firstPhoto: wikiObj?.properties.photoTitle,
                poiType,
                name: wikiObj?.properties.wikiTitle,
                latlon: { lat: coords[1], lon: coords[0] },
                wikiDesc: wikiObj?.properties.wikiDesc,
                background: DEFAULT_POI_SHAPE,
                color: DEFAULT_POI_COLOR,
                icon: currentPoi?.properties[FINAL_POI_ICON_NAME],
                tags: null,
                osmUrl: currentPoi?.properties[POI_OSM_URL],
                wvLinks: wikiObj?.properties.wvLinks,
                lang: wikiObj?.properties.wikiLang,
                wikidata: wikidataId,
                openingHoursValue: currentPoi?.properties[AMENITY_PREFIX + OPENING_HOURS],
                mapObj,
            };
        } else if (type?.isWpt) {
            const newWpt = getDataFromWpt(type, ctx.selectedWpt);
            newWpt.id = ctx.selectedWpt.id;
            newWpt.trackWpt = true;
            return newWpt;
        } else if (type?.isFav || type?.isShareFav) {
            const wpts = ctx.selectedWpt.trackData?.wpts ?? ctx.selectedWpt.wpts;
            const currentWpt = findSelectedWpt(ctx.selectedWpt.markerCurrent, wpts);
            if (currentWpt) {
                const newWpt = getDataFromWpt(type, ctx.selectedWpt, currentWpt);
                newWpt.point = currentWpt;
                newWpt.id = ctx.selectedWpt.groupId;
                newWpt.group = ctx.favorites?.groups?.find((g) => g.id === ctx.selectedWpt.groupId);
                return newWpt;
            }
        } else if (type?.isSearch || type?.isPoi) {
            const currentPoi = ctx.selectedWpt.poi;
            const { options: objOptions, latlng, mapObj } = currentPoi;
            const { name, type: objType } = getPropsFromSearchResultItem(objOptions, t);
            return {
                id: objOptions[POI_ID] ?? currentPoi.key ?? objOptions.idObj,
                type,
                poiType: objType,
                name,
                latlon: { lat: latlng.lat, lon: latlng.lng },
                background: DEFAULT_POI_SHAPE,
                color: DEFAULT_POI_COLOR,
                icon: objOptions[FINAL_POI_ICON_NAME],
                tags: null,
                osmUrl: objOptions[POI_OSM_URL],
                wikipedia: getWikipedia(objOptions[OSM_PREFIX + WIKIPEDIA]),
                openingHoursValue: objOptions[AMENITY_PREFIX + OPENING_HOURS],
                mapObj,
                pending: Boolean(ctx.selectedWpt.mvt),
                stopId: objOptions[TRANSPORT_STOP_ID],
                routes: ctx.selectedWpt.routes,
            };
        } else if (type?.isStop) {
            const currentStop = ctx.selectedWpt.stop;
            const { options: objOptions, latlng, mapObj } = currentStop;
            return {
                id: objOptions.id,
                type,
                name: objOptions.name,
                latlon: { lat: latlng.lat, lon: latlng.lng },
                background: TRANSPORT_STOP_BACKGROUND,
                color: TRANSPORT_STOP_SHIELD_COLOR,
                icon: TRANSPORT_STOP_ICON_NAME,
                stopId: objOptions.id,
                routes: objOptions.routes,
                mapObj,
            };
        }
        return null;
    }, [ctx.selectedWpt]);

    useEffect(() => {
        if (!ctx.selectedWpt) return;

        const type = getWptType(ctx.selectedWpt);

        if ((type?.isFav && !ctx.selectedWpt.mapObj && !isFavoriteFromSearch(ctx)) || type?.isShareFav) {
            recentSaver(FAVORITES_KEY, ctx.selectedWpt);
            ctx.setSelectedFavoriteObj({ ...ctx.selectedWpt });
        }
    }, [ctx.selectedWpt]);

    useEffect(() => {
        if (!newWpt || !ctx.selectedWpt) return;

        const type = getWptType(ctx.selectedWpt);

        if (type?.isStop) {
            const controller = new AbortController();
            setWpt({ ...newWpt });
            setIsAddressAdded(false);
            setIsPhotosAdded(false);
            (async () => {
                let tags = null;
                let osmUrl;
                const stop = ctx.selectedWpt.stop;
                const lat = stop?.latlng?.lat;
                const lon = stop?.latlng?.lng;
                const name = stop?.options?.name ?? '';
                if (lat != null && lon != null) {
                    const response = await getPoiApi({
                        pin: `${Number(lat).toFixed(6)},${Number(lon).toFixed(6)}`,
                        name,
                        type: 'transportation',
                        signal: controller.signal,
                    });
                    if (response?.data) {
                        const options = response.data.properties ?? {};
                        tags = await WptTagsProvider.getWptTags({ options }, { ...type, isPoi: true }, ctx);
                        osmUrl = options[POI_OSM_URL];
                    }
                }
                if (!controller.signal.aborted) {
                    setWpt((prev) =>
                        prev && prev.id === newWpt.id
                            ? { ...prev, tags, ...(osmUrl !== undefined && { osmUrl }) }
                            : prev
                    );
                }
            })();
            return () => controller.abort();
        }

        if (ctx.selectedWpt.mvt) {
            const controller = new AbortController();
            setWpt({ ...newWpt });
            setIsAddressAdded(false);
            setIsPhotosAdded(false);
            const previews = ctx.selectedWpt.mvtPreviews ?? [ctx.selectedWpt];
            loadMvtObjects(previews, controller.signal).then(({ objects, failed }) => {
                if (controller.signal.aborted) {
                    return;
                }
                if (objects.length > 0) {
                    showMvtObject(objects, 0);
                } else if (failed && ctx.selectedWpt.mvt.tags) {
                    // a house is opened by its address, the server has no tags to build an object from
                    ctx.setNotification({ text: 'Failed to load the object', severity: 'error' });
                    closeObjectFromMap();
                } else {
                    setWpt((prev) => (prev?.pending ? { ...prev, pending: false } : prev));
                }
            });
            return () => controller.abort();
        }

        const fetchTagsAndData = async () => {
            let tags;
            if (type?.isWpt) {
                tags = await WptTagsProvider.getWptTags(ctx.selectedWpt, type, ctx);
            } else if (type?.isFav || type?.isShareFav) {
                const wpts = ctx.selectedWpt.trackData?.wpts ?? ctx.selectedWpt.wpts;
                const currentWpt = findSelectedWpt(ctx.selectedWpt.markerCurrent, wpts);
                if (currentWpt) {
                    tags = await WptTagsProvider.getWptTags(currentWpt, type, ctx);
                }
            } else if (type?.isSearch || type?.isPoi || type?.isWikiPoi) {
                const currentPoi = ctx.selectedWpt.poi;
                if (currentPoi) {
                    tags = await WptTagsProvider.getWptTags(currentPoi, type, ctx);
                } else if (newWpt?.wikidata) {
                    const fallbackTags = [];
                    const wikidataTag = addWikidataTags('wikidata', 'Q' + newWpt.wikidata, {
                        key: 'wikidata',
                        value: 'Q' + newWpt.wikidata,
                        textPrefix: 'Wikidata',
                    });
                    fallbackTags.push(wikidataTag);
                    tags = { res: fallbackTags };
                }
            }
            return tags;
        };

        if (!wpt) {
            setLoading(true);
        }

        const controller = new AbortController();
        const openingHoursInfoRequest = getOpeningHoursInfo(newWpt.openingHoursValue, controller.signal);
        Promise.all([fetchTagsAndData(), openingHoursInfoRequest]).then(([tags, openingHours]) => {
            if (controller.signal.aborted) {
                return;
            }
            setWpt((prev) => {
                const base = { ...newWpt, tags, openingHours };
                // preserve address if same POI was already loaded (or its MVT preview)
                if ((prev?.id === newWpt.id || prev?.pending) && prev?.address) {
                    base.address = prev.address;
                }
                return base;
            });
            setIsAddressAdded(false);
            setIsPhotosAdded(false);
            setLoading(false);
        });

        return () => controller.abort();
    }, [newWpt]);

    useEffect(() => {
        if (wpt?.type?.isWikiPoi) {
            if (!ctx.loadingContextMenu && !ctx.searchSettings.getPoi) {
                setShowInfoBlock(false);
            }
        }
    }, [ctx.loadingContextMenu]);

    function getWikiCommons(wikimediaCommons) {
        const WIKIMEDIA_FILE = 'File:';
        const WIKIMEDIA_CATEGORY = 'Category:';

        if (wikimediaCommons && wikimediaCommons.trim() !== EMPTY_STRING) {
            const commonsItems = wikimediaCommons.split(';').map((item) => item.trim());

            const files = [];
            const categories = [];

            commonsItems.forEach((item) => {
                if (item.startsWith(WIKIMEDIA_FILE)) {
                    files.push({
                        type: 'Feature',
                        properties: {
                            imageTitle: item.replace(WIKIMEDIA_FILE, EMPTY_STRING),
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: [0, 0],
                        },
                    });
                } else if (item.startsWith(WIKIMEDIA_CATEGORY)) {
                    categories.push(item.replace(WIKIMEDIA_CATEGORY, EMPTY_STRING));
                }
            });

            return {
                files: files.length > 0 ? files : null,
                categories: categories.length > 0 ? categories[0] : null,
            };
        }
        return null;
    }

    function getWikipedia(wikipedia, tags) {
        let wikiTitle = null;

        const urlInd = !wikipedia ? -1 : wikipedia.indexOf('.wikipedia.org/wiki/');
        if (urlInd > 0) {
            const prefix = wikipedia.substring(0, urlInd);
            const lang = prefix.substring(prefix.lastIndexOf('/') + 1);
            const title = wikipedia.substring(urlInd + '.wikipedia.org/wiki/'.length);
            wikiTitle = `${lang}:${title}`;
        }
        if (!wikiTitle) {
            for (const tag in tags) {
                if (tag.startsWith(WIKIPEDIA + ':')) {
                    wikiTitle = tag.substring((WIKIPEDIA + ':').length) + ':' + tags[tag];
                }
            }
        }
        return wikiTitle ?? wikipedia;
    }

    function getDataFromWpt(type, selectedWpt, wptFromFile = null) {
        const currentWpt = wptFromFile ?? selectedWpt;
        return {
            type: type,
            file: selectedWpt.file,
            trackData: selectedWpt.trackData,
            groupId: selectedWpt.groupId,
            sharedWithMe: selectedWpt.file?.sharedWithMe,
            name: currentWpt.name,
            desc: currentWpt.desc,
            comment: currentWpt.ext?.metadata?.comment,
            hidden: currentWpt.hidden,
            latlon: getCoordsFromWpt(currentWpt),
            marker: currentWpt.marker,
            ...resolveWptAppearance(currentWpt, getResolvedPointsGroups(selectedWpt.trackData)),
            category: currentWpt.category,
            address: currentWpt.address ?? ADDRESS_NOT_FOUND,
            time: parseInt(currentWpt.ext?.time) !== 0 ? currentWpt.ext?.time : null,
            osmUrl: currentWpt.ext?.metadata?.links?.find((l) => l?.href?.includes('openstreetmap.org/'))?.href,
            extensions: currentWpt.ext?.extensions,
            tags: null,
            mapObj: selectedWpt.mapObj,
        };
    }

    function getCoordsFromWpt(wpt) {
        if (wpt.latlng) {
            return { lat: wpt.latlng.lat, lon: wpt.latlng.lng };
        }
        return {
            lat: wpt.lat != null ? parseFloat(wpt.lat) : null,
            lon: wpt.lon != null ? parseFloat(wpt.lon) : null,
        };
    }

    function objWithPhotos(obj) {
        return obj?.type?.isPoi || obj?.type?.isSearch || obj?.type?.isWikiPoi;
    }

    useEffect(() => {
        // the address of an MVT preview is asked at the click point, the loaded object has its own one
        if (!wpt || wpt.address || wpt.pending || isAddressAdded) return;

        setIsAddressAdded(true);
        getPoiAddress(wpt).then((addressData) => {
            setWpt((prev) => {
                if (prev?.id !== wpt?.id) return prev;
                return { ...prev, address: addressData || ADDRESS_NOT_FOUND };
            });
        });
    }, [wpt?.id, wpt?.pending, isAddressAdded]);

    useEffect(() => {
        if (!wpt || !objWithPhotos(wpt) || isPhotosAdded) return;

        setIsPhotosAdded(true);
        getPhotos(wpt).then((photosData) => {
            setWpt((prev) => {
                if (prev?.id !== wpt?.id) return prev;
                return { ...prev, photos: photosData || [] };
            });
        });
    }, [wpt?.id]);

    function getWptType(wpt) {
        return {
            isPoi: ctx.currentObjectType === OBJECT_TYPE_POI && wpt?.poi,
            isSearch: ctx.currentObjectType === OBJECT_SEARCH && wpt?.poi && !wpt?.wikidata,
            isWikiPoi: wpt?.wikidata,
            isWpt: (isTrack(ctx) || isWptFromSearch(ctx)) && wpt?.trackWpt,
            isFav:
                (ctx.currentObjectType === OBJECT_TYPE_FAVORITE ||
                    ctx.selectedSearchObj?.type === OBJECT_TYPE_FAVORITE) &&
                wpt?.markerCurrent,
            isShareFav: ctx.currentObjectType === OBJECT_TYPE_SHARE_FILE && wpt?.markerCurrent,
            isStop: ctx.currentObjectType === OBJECT_TYPE_STOP && wpt?.stop,
        };
    }

    function closeDetails() {
        const type = wpt?.type;
        if (!type) return;

        ctx.setSelectedWpt(null);

        if (type.isStop) {
            ctx.setSelectedTransportRoute(null);
        }

        if (type.isPoi || type.isSearch) {
            if (ctx.selectedWptId) {
                ctx.setSelectedWptId((prev) => {
                    return { ...prev, show: false };
                });
            }
            if (!wpt.mapObj) {
                ctx.setSelectedPoiObj(null);
                setShowInfoBlock(false);
                navigate({
                    pathname: MAIN_URL_WITH_SLASH + SEARCH_URL + SEARCH_RESULT_URL,
                    search: buildSearchParamsFromQuery(ctx.searchQuery),
                    hash: liveHash(),
                });
            } else {
                closeObjectFromMap();
            }
        } else if (type.isWpt) {
            if (isWptFromSearch(ctx)) {
                ctx.setSelectedSearchObj(null);
                ctx.setCurrentObjectType(null);
                ctx.setSelectedGpxFile({});
                setShowInfoBlock(false);
                navigateBackToSearchResults(navigate, ctx, location);
            } else {
                !wpt.mapObj || ctx.selectedCloudTrackObj ? setOpenWptTab(true) : closeObjectFromMap();
            }
        } else if (type.isWikiPoi) {
            if (ctx.selectedWptId) {
                ctx.setSelectedWptId((prev) => {
                    return { ...prev, show: false };
                });
            }
            setShowInfoBlock(false);
            if (wpt.mapObj) {
                ctx.setSearchSettings((prev) => ({ ...prev, getPoi: null }));
                closeObjectFromMap();
            } else {
                closeWikiPoi(ctx);
                navigate({
                    pathname: MAIN_URL_WITH_SLASH + SEARCH_URL + (ctx.exploreMenu ? EXPLORE_URL : ''),
                    hash: liveHash(),
                });
            }
        } else if (type.isFav) {
            if (isFavoriteFromSearch(ctx)) {
                // Opened from search — always return to search results.
                ctx.setSelectedSearchObj(null);
                setShowInfoBlock(false);
                if (!wpt.mapObj) {
                    ctx.setSelectedFavoriteObj(null);
                }
                navigateBackToSearchResults(navigate, ctx, location);
            } else if (!wpt.mapObj) {
                ctx.setSelectedFavoriteObj(null);
                closeOnlyFavDetails();
            } else {
                // remove the selected pin from the map
                ctx.setCloseMapObj(true);
                closeOnlyFavDetails();
            }
        } else if (type.isShareFav) {
            setShowInfoBlock(false);
            ctx.setSelectedGpxFile((prev) => ({ ...prev, markerCurrent: null, favItem: false, name: null }));
        } else if (type.isStop) {
            if (wpt.mapObj) {
                closeObjectFromMap();
            }
        }
    }

    function showMvtObject(objects, index) {
        const obj = { ...objects[index], mvtObjects: objects, mvtIndex: index };
        recentSaver(POI_OBJECTS_KEY, obj.poi);
        ctx.setSelectedWptId({ id: obj.poi.options[POI_ID], show: false, type: POI_LAYER_ID });
        ctx.setCurrentObjectType(OBJECT_TYPE_POI);
        ctx.setSelectedWpt(obj);
        if (obj.inPoiIndex) {
            navigateToPoi(obj, navigate);
        } else {
            navigateToPin(obj.poi.latlng, navigate);
        }
    }

    function closeObjectFromMap() {
        ctx.setCurrentObjectType(null);
        ctx.setSelectedWpt(null);

        if (ctx.poiByUrl?.layer) {
            // remove poi marker
            ctx.setPoiByUrl((prev) => {
                return {
                    ...prev,
                    open: false,
                };
            });
        }

        if (ctx.stopByUrl?.layer) {
            // remove stop marker
            ctx.setStopByUrl((prev) => {
                return {
                    ...prev,
                    open: false,
                };
            });
        }

        ctx.setCloseMapObj(true);
    }

    function closeOnlyFavDetails() {
        setShowInfoBlock(false);
        ctx.setCurrentObjectType(null);
        navigateToFavoritesMenu(navigate, ctx);
        ctx.setSelectedGpxFile({});
    }

    function getId() {
        if (wpt.type?.isFav) {
            return 'se-fav-item-info-' + wpt.name;
        }
        if (wpt.type?.isWpt) {
            return 'se-wpt-item-info-' + wpt.name;
        }
        if (wpt.type?.isPoi) {
            return 'se-poi-infoblock-' + wpt.name;
        }
        return null;
    }

    function formatTime(time) {
        return fmt.dateTimeShort(time);
    }

    function getPoiAddress(wpt) {
        return getAddressByLatLon(wpt.latlon?.lat, wpt.latlon?.lon);
    }

    async function getPhotos(wpt) {
        let tags;
        const rawTags = wpt.tags?.rawTags;
        const wikidataId = wpt.wikidata;
        if (!rawTags && wikidataId) {
            tags = {
                wikidata: wikidataId,
            };
        } else if (rawTags) {
            tags = Object.fromEntries(Object.entries(rawTags).map(([key, value]) => [key, String(value)]));
            if (!tags[WIKIDATA] && wikidataId) {
                tags[WIKIDATA] = wikidataId;
            }
        }
        if (!tags) {
            return null;
        }
        const response = await apiPost(`${process.env.REACT_APP_USER_API_SITE}/search/get-poi-photos`, tags, {
            apiCache: true,
        });

        let result;
        if (response?.data) {
            result = response.data;
        } else {
            return null;
        }

        for (const tagKey of Object.keys(tags)) {
            if (otherImgTags(tagKey)) {
                let imgFeature;
                if (tagKey === MAPILLARY_OSM_TAG) {
                    const link = await getMapillaryLink(tags[MAPILLARY_OSM_TAG]);
                    imgFeature = createTagImg({ tags, tagKey, link });
                } else {
                    imgFeature = createTagImg({ tags, tagKey });
                }
                if (imgFeature) {
                    result.features.push(imgFeature);
                }
            }
        }

        return result;
    }

    async function getMapillaryLink(tagValue) {
        const url = `${GRAPH_URL_ENDPOINT}${tagValue}?${PARAM_ACCESS_TOKEN}&${PARAM_FIELDS}`;

        return fetch(url)
            .then((response) => {
                if (!response.ok) {
                    return null;
                }
                return response.json();
            })
            .then((data) => findBestThumbnail(data))
            .catch(() => {
                return null;
            });
    }

    function createTagImg({ tags, tagKey, link = null }) {
        const tagValue = tags[tagKey];

        if (!tagValue) return null;

        if (wpt.latlon?.lat == null || wpt.latlon?.lon == null) {
            return null;
        }

        return {
            type: 'Feature',
            properties: {
                imageTitle: link ?? tagValue,
                osmTag: tagKey,
                mediaId: 0,
                rowNum: 0,
            },
            geometry: {
                type: 'Point',
                coordinates: [wpt.latlon.lon, wpt.latlon.lat],
            },
        };
    }

    function findBestThumbnail(data) {
        if (!data) return null;

        if (data.thumb_1024_url) return data.thumb_1024_url;

        for (const key in data) {
            if (key.startsWith('thumb') && key.endsWith('url')) {
                return data[key];
            }
        }
        return null;
    }

    function showFavoriteActions() {
        return wpt.type.isFav || wpt.type.isShareFav || (wpt.type.isWpt && isLocalTrack(ctx));
    }

    function showPoiActions() {
        return wpt.type.isPoi || wpt.type.isWikiPoi || wpt?.type?.isSearch;
    }

    function showTransportStopActions() {
        return wpt?.type?.isStop;
    }

    // several objects under one click on the map: the menu shows them one by one
    const MapObjectsNav = () => {
        const objects = ctx.selectedWpt?.mvtObjects;
        if (!objects || objects.length < 2) {
            return null;
        }
        const index = ctx.selectedWpt.mvtIndex;
        return (
            <>
                {index > 0 && (
                    <ActionIconBtn
                        id="se-prev-map-object"
                        icon={<ArrowBackIcon />}
                        aria-label={t('shared_string_previous')}
                        onClick={() => showMvtObject(objects, index - 1)}
                    />
                )}
                <ActionIconBtn
                    id="se-next-map-object"
                    icon={<ArrowForwardIcon />}
                    aria-label={t('shared_string_next')}
                    disabled={index === objects.length - 1}
                    onClick={() => showMvtObject(objects, index + 1)}
                />
            </>
        );
    };

    const Header = () => {
        // newWpt knows the origin at once, wpt only after the details are loaded
        const mapObj = newWpt?.mapObj;

        return (
            <HeaderWithUnderline
                onClose={() => closeDetails()}
                showBackButton={!mapObj}
                appBarProps={{ id: mapObj ? 'se-close-wpt-details' : 'se-back-wpt-details' }}
                rightContent={<MapObjectsNav />}
            />
        );
    };

    const WptGroup = () => {
        return (
            <Box className={styles.wptCategory}>
                <ListItemIcon
                    style={{
                        color:
                            wpt.category &&
                            FavoritesManager.getColorGroup({ gpxFile: wpt.file, groupName: wpt.category }),
                        minWidth: 'auto',
                    }}
                >
                    <Folder fontSize="small" />
                </ListItemIcon>
                <Box>
                    <MenuItemWithLines
                        id={'se-wpt-group'}
                        name={getWptGroup(wpt)}
                        maxLines={1}
                        className={styles.wptCategoryText}
                    />
                </Box>
            </Box>
        );
    };

    function getWptGroup(wpt) {
        let groupStr = wpt.category ?? 'Favorites';
        const groupLength = wpt.trackData ? wpt.trackData.wpts.length : wpt?.wpts?.length;
        if (groupLength) {
            groupStr += ` (${groupLength})`;
        }
        return groupStr;
    }

    function getWptTrackName(wpt) {
        return wpt.type?.isWpt && wpt.trackData?.name ? prepareName(wpt.trackData.name, true) : null;
    }

    const WikiVoyageLinks = ({ wvLinks }) => {
        const [open, setOpen] = useState(false);

        const value = Object.values(wvLinks)
            .map((link) => link[0])
            .join(' • ');

        return (
            <>
                <MenuItem style={{ userSelect: 'text' }} disableRipple className={wptStyles.tagItem} divider>
                    <WikiIcon className={wptStyles.tagIcon} />
                    <>
                        <ListItemText onClick={() => setOpen(!open)}>
                            <MenuItemWithLines
                                name={t('shared_string_wikivoyage')}
                                maxLines={1}
                                className={wptStyles.tagPrefix}
                            />
                            {Object.keys(wvLinks).length > 1 ? (
                                <MenuItemWithLines name={value} maxLines={1} className={wptStyles.tagName} />
                            ) : (
                                <Link href={Object.values(wvLinks)[0][1]} target="_blank" rel="noopener noreferrer">
                                    {Object.values(wvLinks)[0][1]}
                                </Link>
                            )}
                        </ListItemText>
                        {Object.keys(wvLinks).length > 1 && (
                            <IconButton onClick={() => setOpen(!open)}>
                                {open ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        )}
                    </>
                </MenuItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    {Object.values(wvLinks).map((item, index) => (
                        <MenuItem
                            disableRipple={!ctx.develFeatures}
                            onClick={() => {
                                openWikivoyageContent(item, setDevWikiContent);
                            }}
                            key={index}
                            divider
                            className={wptStyles.tagList}
                        >
                            <Link href={item[1]} target="_blank" rel="noopener noreferrer">
                                {item[0]}
                            </Link>
                        </MenuItem>
                    ))}
                </Collapse>
            </>
        );
    };

    const WptName = () => {
        let name = wpt.name;
        if (!name) {
            name = wpt.poiType ? getFirstSubstring(wpt.poiType) : 'No name';
        }
        if (wpt.osmUrl) {
            return (
                <Typography id={'se-wpt-name'} className={styles.name}>
                    <Link href={wpt.osmUrl} target="_blank" underline="none">
                        {name}
                    </Link>
                </Typography>
            );
        } else {
            return (
                <Typography id={'se-wpt-name'} className={styles.name}>
                    {wpt.name ?? 'No name'}
                </Typography>
            );
        }
    };

    const shortDescription = !wpt?.type?.isWpt && getShortDescription(getShortDescriptions(wpt?.extensions));

    return (
        <>
            {showLoading ? (
                <Loading />
            ) : (
                <Box
                    sx={{
                        height: `${height - HEADER_SIZE}px`,
                        minWidth: ctx.infoBlockWidth,
                        maxWidth: ctx.infoBlockWidth,
                    }}
                    className={gStyles.scrollMainBlock}
                >
                    <Header />
                    <Box className={gStyles.scrollActiveBlock}>
                        {wpt !== null && (
                            <ListItemText id={getId()} sx={{ mt: 0 }}>
                                <Box id={'se-wpt-details'} className={styles.topContainer}>
                                    <div>
                                        <MenuItemWithLines maxLines={3} className={styles.name}>
                                            <WptName />
                                        </MenuItemWithLines>
                                        <MenuItemWithLines
                                            className={styles.type}
                                            name={getObjType(wpt, t) || (wpt.pending ? TYPE_PLACEHOLDER : null)}
                                            maxLines={2}
                                        />
                                    </div>
                                    {wpt.icon ? (
                                        <WptIcon
                                            wpt={wpt}
                                            color={wpt.color}
                                            background={wpt.background}
                                            icon={wpt.icon}
                                            iconSize={ICON_IMG_SIZE}
                                            shieldSize={ICON_SHIELD_SIZE}
                                            ctx={ctx}
                                        />
                                    ) : (
                                        wpt.pending && <div className={styles.iconPlaceholder} />
                                    )}
                                </Box>
                                {wpt?.category && <WptGroup />}
                                {wpt?.openingHours && <OpeningHoursInfo openingHours={wpt.openingHours} />}
                                <LocationInfoLine wpt={wpt} />
                                {showFavoriteActions() && <FavoriteActionsButtons wpt={wpt} />}
                                {showPoiActions() && <PoiActionsButtons wpt={wpt} />}
                                {showTransportStopActions() && <TransportStopActionsButtons wpt={wpt} />}
                                {(wpt?.type?.isStop || wpt?.stopId) && <TransportStopsRoutes wpt={wpt} />}
                                {wpt?.wikiDesc && (
                                    <>
                                        <Divider />
                                        <MenuItem className={styles.descTitle}>
                                            <ListItemText>
                                                <Typography className={styles.descTitleText}>
                                                    {t('shared_string_description')}
                                                </Typography>
                                            </ListItemText>
                                        </MenuItem>
                                        <div className={styles.descTextBlock}>
                                            <Typography id={'se-wpt-desc'} className={styles.descText}>
                                                {parse(cleanHtml(wpt?.wikiDesc || EMPTY_STRING))}
                                            </Typography>
                                        </div>
                                        <Button
                                            sx={{ ml: 1 }}
                                            onClick={() =>
                                                window.open(
                                                    'https://' + wpt.lang + '.wikipedia.org/wiki/' + wpt.name,
                                                    '_blank'
                                                )
                                            }
                                        >
                                            {t('shared_string_read_more')}
                                        </Button>
                                    </>
                                )}
                                <Divider />
                                {wpt.photos && <PhotoGallery photos={wpt.photos} />}
                                {wpt.elo && ctx.develFeatures && (
                                    <WptTagInfo
                                        key={'elo'}
                                        baseTag={{
                                            icon: <InfoIcon />,
                                            name: 'Elo',
                                            value: Number(wpt.elo).toFixed(0),
                                        }}
                                    />
                                )}
                                {wpt.wvLinks && <WikiVoyageLinks wvLinks={wpt.wvLinks} />}
                                {wpt.desc && (
                                    <WptTagInfo
                                        key={'desc'}
                                        baseTag={{
                                            icon: <DescriptionIcon />,
                                            name: t('shared_string_description'),
                                            value: wpt.desc,
                                            isDesc: true,
                                        }}
                                    />
                                )}
                                {shortDescription && (
                                    <WptTagInfo
                                        key={'short-desc'}
                                        baseTag={{
                                            icon: <WikiIcon />,
                                            name: t('web:wiki_description'),
                                            value: shortDescription,
                                            isDesc: true,
                                        }}
                                    />
                                )}
                                {wpt.comment && (
                                    <WptTagInfo
                                        key={'comment'}
                                        baseTag={{
                                            icon: <DescriptionIcon />,
                                            name: t('poi_dialog_comment'),
                                            value: wpt.comment,
                                        }}
                                    />
                                )}
                                {wpt.time && (
                                    <WptTagInfo
                                        key={'time'}
                                        baseTag={{
                                            icon: <TimeIcon />,
                                            name: t('date_of_creation'),
                                            value: formatTime(wpt.time),
                                        }}
                                    />
                                )}
                                {wpt?.hidden === 'true' && (
                                    <WptTagInfo
                                        key={'hidden'}
                                        baseTag={{
                                            icon: <InfoIcon />,
                                            name: t('shared_string_hidden'),
                                            value: t('shared_string_yes'),
                                        }}
                                    />
                                )}
                                {wpt.category && (
                                    <WptTagInfo
                                        key={'folder'}
                                        baseTag={{
                                            icon: <FolderIcon />,
                                            name: t('folder'),
                                            value: wpt.category,
                                        }}
                                    />
                                )}
                                {getWptTrackName(wpt) && (
                                    <WptTagInfo
                                        key={'track'}
                                        baseTag={{
                                            icon: <TrackIcon />,
                                            name: t('shared_string_gpx_track'),
                                            value: getWptTrackName(wpt),
                                        }}
                                    />
                                )}
                                {wpt.pending ? (
                                    showPendingLoading && <Loading />
                                ) : (
                                    <>
                                        {renderedTags
                                            ?.filter((t) => filterTag(t))
                                            .map((t, index) => (
                                                <WptTagInfo
                                                    key={t?.key ?? index}
                                                    tag={t}
                                                    setDevWikiContent={setDevWikiContent}
                                                />
                                            ))}
                                        {wpt.osmUrl && (
                                            <WptTagInfo
                                                key={'osm'}
                                                baseTag={{
                                                    icon: <OsmIcon />,
                                                    name: 'OSM ID',
                                                    link: (
                                                        <Link
                                                            href={wpt.osmUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {getOsmIdFromOsmUrl(wpt.osmUrl)}
                                                        </Link>
                                                    ),
                                                }}
                                            />
                                        )}
                                        {wpt.latlon?.lat != null && wpt.latlon?.lon != null && (
                                            <WptTagInfo
                                                key={'latlon'}
                                                copy={true}
                                                baseTag={{
                                                    icon: <LocationIcon />,
                                                    name: t('coordinates'),
                                                    value: wpt.latlon.lat.toFixed(6) + ', ' + wpt.latlon.lon.toFixed(6),
                                                }}
                                            />
                                        )}
                                    </>
                                )}
                                {wpt.wikidata && ltx.isAdmin() && (
                                    <>
                                        <Divider />
                                        <MenuItem className={styles.descTitle}>
                                            <ListItemText>
                                                <Typography className={styles.descTitleText}>
                                                    {t('web:developer')}
                                                </Typography>
                                            </ListItemText>
                                        </MenuItem>
                                        <WptTagInfo
                                            key={'top-photos'}
                                            baseTag={{
                                                icon: (
                                                    <PhotoLibraryOutlinedIcon sx={{ color: 'var(--svg-icon-color)' }} />
                                                ),
                                                name: t('web:dev_top_photos'),
                                                link: (
                                                    <Link
                                                        href={`${window.location.origin}/admin/top-photos/per-place?placeId=${wpt.wikidata}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {wpt.wikidata}
                                                    </Link>
                                                ),
                                            }}
                                        />
                                    </>
                                )}
                            </ListItemText>
                        )}
                    </Box>
                </Box>
            )}
            {devWikiContent && (
                <Dialog open={true}>
                    <DialogContent>
                        <DialogContentText>{parse(devWikiContent)}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDevWikiContent(null)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

// objects clicked on the MVT layer: full POI (same as in search results, from the tags when not in the POI index),
// for a public transport POI its stop with routes (as Android AmenityMenuController)
async function loadMvtObjects(previews, signal) {
    const objects = [];
    let failed = false;
    for (const preview of previews) {
        const loaded = await getPoiByMapObject(preview.mvt, preview.poi.latlng, signal);
        failed = failed || loaded.failed;
        if (loaded.pois.length === 0 && !preview.mvt.tags) {
            objects.push({ poi: preview.poi, inPoiIndex: false });
        }
        for (const poi of loaded.pois) {
            const stopId = poi.options[TRANSPORT_STOP_ID];
            const stop = stopId ? await getTransportStop(stopId, poi.latlng, signal) : null;
            objects.push({ poi, routes: stop?.options?.routes, inPoiIndex: !poi.options[POI_FROM_TAGS] });
        }
    }

    return { objects, failed };
}

async function getTransportStop(stopId, latlng, signal) {
    const response = await getTransportStopApi({ lat: latlng.lat, lon: latlng.lng, stopId, signal });

    return createMapObject(response?.data);
}

async function getOpeningHoursInfo(openingHoursValue, signal) {
    if (!openingHoursValue) {
        return null;
    }
    const response = await getOpeningHoursInfoApi({ openingHours: openingHoursValue, signal });

    return getOpeningHours(response?.data);
}

async function getPoiByMapObject({ mapObjectId, tags }, latlng, signal) {
    const response = await getPoiByMapObjectApi({
        lat: latlng.lat,
        lon: latlng.lng,
        id: mapObjectId,
        tags: stringifyTagValues(tags ?? {}),
        signal,
    });

    return {
        pois: (response?.data?.features ?? []).map((feature) => createPoiObject(feature, tags)),
        failed: response?.ok === false && !response.aborted,
    };
}

function createPoiObject(feature, tags) {
    const props = feature.properties;
    if (props[POI_FROM_TAGS] && !hasTypeTranslation(getFirstSubstring(props[POI_SUBTYPE]))) {
        const tagType = findTranslatedTag(tags);
        if (tagType) {
            props[POI_SUBTYPE] = tagType;
            props[ICON_KEY_NAME] = tagType;
        }
    }
    props[FINAL_POI_ICON_NAME] = getFinalPoiIconName(props);

    return createMapObject(feature);
}

function getShortDescription(shortDescriptions) {
    return (
        shortDescriptions[getShortDescriptionKey(getWikiLang(i18n.language))] ??
        shortDescriptions[getShortDescriptionKey()] ??
        Object.values(shortDescriptions)[0]
    );
}
